export default __webpack_public_path__ + "static/media/Branch of the Great Tree.4abf3f72.jpg";